import axios from 'axios';

const SecurityConfigurationApiUrl = 'SecurityConfiguration';

export const SecurityConfigurationService = {
  async GetSecurityConfiguration(entityTypeId: number, entityPk: string): Promise<any> {
    const response = await axios.get(`${SecurityConfigurationApiUrl}/${entityTypeId}/${entityPk}`);
    return response.data;
  },
  async UpdateSecurityConfiguration(entityTypeId: number, entityPk: string, securityEntity: any) {
    const response = await axios.put(`${SecurityConfigurationApiUrl}/${entityTypeId}/${entityPk}`, securityEntity);
    return response.data;
  }
};
